export default __webpack_public_path__ + "static/media/2020-4.cde98516.jpeg";